module.exports = __webpack_public_path__ + "img/14.missing_paper_towel.3b3f3ced.svg";